import { Contract } from "../../types";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";
import { PdtIcon } from "../atoms/PdtIcon";
import { Typography } from "../atoms/Typography";
import { Tooltip } from "../atoms/Tooltip";
import styled from "styled-components";

type ContractNotificationRecipientListProps = {
  contracts: Contract[];
};

const headerTitles = ["製品", "通知先"];

const flexRatio = [0.3, 6.2];

const EmailContact = styled.span`
  padding: 4px 8px;
  border: 1px solid ${(props) => props.theme.colors.primaryBorder};
  border-radius: 4px;
`;

const EmailContactWrapper = styled.div`
  margin-right: 4px;
  display: inline-block;
`;

function Member({
  emailContact,
}: {
  emailContact: {
    id: string;
    emailAddress: string;
    name: string;
    department?: string;
  };
}) {
  const tooltipContent = `${emailContact.name}${emailContact.department ? ` / ${emailContact.department}` : ""} / ${emailContact.emailAddress}`;
  return (
    <EmailContactWrapper>
      <Tooltip content={tooltipContent}>
        <EmailContact>
          <Typography size={2} as="span">
            {emailContact.name}
          </Typography>
        </EmailContact>
      </Tooltip>
    </EmailContactWrapper>
  );
}

function NotificationRecipient({ contract }: { contract: Contract }) {
  const names = contract.notificationRecipients?.map((recipient) => (
    <Member
      key={recipient.emailContact.id}
      emailContact={recipient.emailContact}
    />
  ));

  return (
    <DataListRow flexRatio={flexRatio}>
      <DataListBodyItem>
        <PdtIcon
          size={40}
          src={contract.pdt.iconPath}
          alt={contract.pdt.name}
        />
      </DataListBodyItem>
      <DataListBodyItem>{names}</DataListBodyItem>
    </DataListRow>
  );
}

export function ContractNotificationRecipientList({
  contracts,
}: ContractNotificationRecipientListProps) {
  const rows = contracts.map((contract: Contract) => (
    <NotificationRecipient key={contract.id} contract={contract} />
  ));
  return (
    <DataTable>
      <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
      <DataListBody rows={rows} />
    </DataTable>
  );
}
